import React from "react";
import FacilitiesBannerSkeleton from "./skeleton/FacilitiesBannerSkeleton";

const FacilitiesBanner = ({ banner, loading }) => {
  if (!banner || loading) {
    return <FacilitiesBannerSkeleton />;
  }

  return (
    <div style={{ textAlign: "center" }}>
      <img src={banner} style={{height: 197, width: 411}} alt="banner" className="img-fluid" />
    </div>
  );
};

export default FacilitiesBanner;
